import { useLocation, useRouter } from '@tanstack/react-router';

import {
  readPostNotificationDialog,
  readPostNotificationOrigin,
  type PostNotificationDialog,
} from '../model/postNotificationNavigation';

export const usePostNotificationNavigation = (dialog?: PostNotificationDialog) => {
  const router = useRouter();
  const location = useLocation();
  const restoredDialog = readPostNotificationDialog(location.state);
  const origin = readPostNotificationOrigin(location.state);
  const destinationState = dialog
    ? {
        postNotificationOrigin: {
          ...dialog,
          href: location.href,
          index: location.state.__TSR_index,
        },
      }
    : {};

  const rememberDialog = () => {
    if (!dialog) return;
    const current = router.history.location;
    router.history.replace(current.href, { ...current.state, postNotificationDialog: dialog });
    // Browser history batches writes. Persist the source entry before the Link pushes settings.
    router.history.flush();
  };
  const openPreviewSettings = (href: string) => {
    rememberDialog();
    void router.navigate({
      href,
      state: (state) => ({ ...state, ...destinationState, postNotificationDialog: undefined }),
    });
  };
  const clearDialog = () => {
    const current = router.history.location;
    if (!readPostNotificationDialog(current.state)) return;
    router.history.replace(current.href, { ...current.state, postNotificationDialog: undefined });
  };
  const returnToPost = () => {
    if (!origin) return;
    if (
      router.history.location.state.__TSR_index === origin.index + 1 &&
      router.history.canGoBack()
    )
      router.history.back();
    else
      void router.navigate({
        href: origin.href,
        replace: true,
        state: (state) => ({
          ...state,
          postNotificationOrigin: undefined,
          postNotificationDialog: { postId: origin.postId, surface: origin.surface },
        }),
      });
  };

  return {
    restoredDialog,
    origin,
    destinationState,
    rememberDialog,
    openPreviewSettings,
    clearDialog,
    returnToPost,
  };
};
